export * from './ChatSupportProvider';
export * from './useChatSupportWidget';

// This is the URL we give to users where FAQs and Support Documentation is
export const SUPPORT_URL = 'https://support.castingnetworks.com';
